import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({
    className,
    ...props
}, ref) => (
    <SwitchPrimitives.Root
        className={generateValidClassNameHandler(
            "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-primary-foreground",
            className,
        )}
        {...props}
        ref={ref}
    >
        <SwitchPrimitives.Thumb className={generateValidClassNameHandler("pointer-events-none block size-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0")} />
    </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
